/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import ReportDataForList from './ReportDataForList';





/**
* The Reports model module.
* @module model/Reports
* @version 1.0.0
*/
export default class Reports extends Array {
    /**
    * Constructs a new <code>Reports</code>.
    * Список всех отчетов. Новые отчеты должны быть самыми первыми в списке.
    * @alias module:model/Reports
    * @class
    * @extends Array
    */

    constructor() {
        
        super();
        

        
        

        

        return this;
    }

    /**
    * Constructs a <code>Reports</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Reports} obj Optional instance to populate.
    * @return {module:model/Reports} The populated <code>Reports</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Reports();

            ApiClient.constructFromObject(data, obj, 'ReportDataForList');

            
            

        }
        return obj;
    }









}


